export default "__VITE_ASSET__e7d1189c__"